import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { useEffect, useRef } from 'react';
import useDepositInputStore from './useDepositInputStore';
import { useSpotMarketsSortedByMarketIndex } from 'src/hooks/spotMarkets/useSpotMarketsSortedByMarketIndex';

export const useSyncedDepositInput = (
	defaultMax: boolean,
	biggestAssetMarket: SpotMarketConfig,
	collateralTypeIndex: number,
	currentKey: string
) => {
	const setDepositInputStore = useDepositInputStore((s) => s.set);

	const selectedCollatBank = useDepositInputStore((s) => s.selectedSpotMarket);
	const depositInputAmount = useDepositInputStore((s) => s.depositInputAmount);
	const targetAccountKeyInput = useDepositInputStore(
		(s) => s.targetUserAccountKey
	);
	const persistInputAmountInput = useDepositInputStore(
		(s) => s.persistInputAmount
	);

	const persistInputAmountRef = useRef(persistInputAmountInput);
	const spotMarketsSortedByMarketIndex = useSpotMarketsSortedByMarketIndex();

	useEffect(() => {
		setSelectedCollatBank(
			defaultMax
				? biggestAssetMarket
				: spotMarketsSortedByMarketIndex[collateralTypeIndex]
		);
	}, [
		defaultMax,
		biggestAssetMarket,
		collateralTypeIndex,
		spotMarketsSortedByMarketIndex,
	]);

	useEffect(() => {
		setDepositInputStore((s) => {
			s.targetUserAccountKey = currentKey;
		});
	}, [currentKey]);

	useEffect(() => {
		persistInputAmountRef.current = persistInputAmountInput;
	}, [persistInputAmountInput]);

	const setTargetAccountKey = (newKey: string) => {
		setDepositInputStore((s) => {
			s.targetUserAccountKey = newKey;
		});
	};

	const setSelectedCollatBank = (newCollat: SpotMarketConfig) => {
		setDepositInputStore((s) => {
			s.selectedSpotMarket = newCollat;
		});
	};

	const setCollatTransferAmount = (newAmount: string) => {
		setDepositInputStore((s) => {
			s.depositInputAmount = newAmount;
		});
	};

	const setPersistInputAmount = (newPersistInputAmount: boolean) => {
		setDepositInputStore((s) => {
			s.persistInputAmount = newPersistInputAmount;
		});
	};

	const setSelectedMarket = (newMarket: SpotMarketConfig) => {
		setDepositInputStore((s) => {
			s.selectedSpotMarket = newMarket;
		});
	};

	return {
		selectedCollatBank,
		depositInputAmount,
		targetAccountKeyInput,
		persistInputAmountRef,
		setSelectedCollatBank,
		setCollatTransferAmount,
		setTargetAccountKey,
		setPersistInputAmount,
		setSelectedMarket,
	};
};
